import React from "react";
import WorshipRecord from "./WorshipRecord";
import RandomYouTubePlayer from "./components/RandomYouTubePlayer";

const Worship = () => (
  <>
    <WorshipRecord watermarkText="GlobalChristianCommunity.com" />
  </>
);

export default Worship;
